<template>
  <div class="fantan-mainbet">
    <div
      ref="square1"
      class="square1"
      :class="{'square-active':(Array.isArray(win_ssh))?(win_ssh.includes(gameRow[2])):(win_ssh === gameRow[2])}"
    >
      <new-bet-lot
        class="fantan-ssh"
        game="fantan-ssh"
        display="ssh241"
        :key="o2"
        :type="gameRow[2]"
        :odd="odd(o2)"
        :category="o2"
        :gameType="game"
        :game-data="gameData"
        :minutes-string="minutesString"
        :seconds-string="secondsString"
        :disallow-betting="disallowBetting"
        :stake-record-sum="stakeRecordSum(gameRow[2])"
        @update-session-storage="onUpdateSessionStorage"
      />
    </div>
    <div
      ref="square2"
      class="square2"
      :class="{'square-active':(Array.isArray(win_ssh))?(win_ssh.includes(gameRow[1])):(win_ssh === gameRow[1])}"
    >
      <new-bet-lot
        class="fantan-ssh1"
        game="fantan-ssh"
        display="ssh234"
        :key="o2"
        :type="gameRow[1]"
        :odd="odd(o2)"
        :category="o2"
        :gameType="game"
        :game-data="gameData"
        :minutes-string="minutesString"
        :seconds-string="secondsString"
        :disallow-betting="disallowBetting"
        :stake-record-sum="stakeRecordSum(gameRow[1])"
        @update-session-storage="onUpdateSessionStorage"
      />
    </div>
    <div
      ref="square3"
      class="square3"
      :class="{'square-active':(Array.isArray(win_ssh))?(win_ssh.includes(gameRow[3])):(win_ssh === gameRow[3])}"
    >
      <new-bet-lot
        class="fantan-ssh"
        game="fantan-ssh"
        display="ssh341"
        :key="o2"
        :type="gameRow[3]"
        :odd="odd(o2)"
        :category="o2"
        :gameType="game"
        :game-data="gameData"
        :minutes-string="minutesString"
        :seconds-string="secondsString"
        :disallow-betting="disallowBetting"
        :stake-record-sum="stakeRecordSum(gameRow[3])"
        @update-session-storage="onUpdateSessionStorage"
      />
    </div>
    <div
      ref="square4"
      class="square4"
      :class="{'square-active':(Array.isArray(win_ssh))?(win_ssh.includes(gameRow[0])):(win_ssh === gameRow[0])}"
    >
      <new-bet-lot
        class="fantan-ssh1"
        game="fantan-ssh"
        display="ssh123"
        :key="o2"
        :type="gameRow[0]"
        :odd="odd(o2)"
        :category="o2"
        :gameType="game"
        :game-data="gameData"
        :minutes-string="minutesString"
        :seconds-string="secondsString"
        :disallow-betting="disallowBetting"
        :stake-record-sum="stakeRecordSum(gameRow[0])"
        @update-session-storage="onUpdateSessionStorage"
      />
    </div>
  </div>
</template>

<script>
import { Row, Col, Button } from "iview";
import { TweenLite, TimelineLite } from "gsap";
import NewBetLot from "../../commons/NewBetLot";
import betLotMixin from "../../../mixins/bet-lot-mixin";

export default {
  mixins: [betLotMixin],
  props: [
    "game",
    "winNumbers",
    "gameData",
    "drawResult",
    "animation",
    "onTabEnd",
  ],
  components: {
    Row,
    Col,
    Button,
    NewBetLot,
  },
  data() {
    return {
      o2: "o2",
      gameRow: ["ssh123", "ssh234", "ssh241", "ssh341"],
      winCell: [],
    };
  },
  watch: {
    animation(newVal) {
      let vm = this;
      if (newVal) {
        let emptySquare = new TimelineLite();

        emptySquare
          .set(vm.$refs["square2"], {
            opacity: 0,
          })
          .set(vm.$refs["square1"], {
            opacity: 0,
          })
          .set(vm.$refs["square3"], {
            opacity: 0,
          })
          .set(vm.$refs["square4"], {
            opacity: 0,
          });
        TweenLite.fromTo(
          vm.$refs["square2"],
          0.2,
          {
            y: 200,
            opacity: 0,
          },
          {
            y: 0,
            opacity: 1,
            onComplete: function () {
              TweenLite.set(vm.$refs["square2"], {
                clearProps: "all",
              });
              TweenLite.fromTo(
                vm.$refs["square1"],
                0.2,
                {
                  x: 200,
                  opacity: 0,
                },
                {
                  x: 0,
                  opacity: 1,
                  onComplete: function () {
                    TweenLite.set(vm.$refs["square1"], {
                      clearProps: "all",
                    });
                    TweenLite.fromTo(
                      vm.$refs["square3"],
                      0.2,
                      {
                        y: 200,
                        opacity: 0,
                      },
                      {
                        y: 0,
                        opacity: 1,
                        onComplete: function () {
                          TweenLite.set(vm.$refs["square3"], {
                            clearProps: "all",
                          });
                          TweenLite.fromTo(
                            vm.$refs["square4"],
                            0.2,
                            {
                              x: -200,
                              opacity: 0,
                            },
                            {
                              x: 0,
                              opacity: 1,
                              onComplete: function () {
                                TweenLite.set(vm.$refs["square4"], {
                                  clearProps: "all",
                                });
                                vm.tabEnd();
                              },
                            }
                          );
                        },
                      }
                    );
                  },
                }
              );
            },
          }
        );
      }
    },
  },
  computed: {
    win_ssh() {
      this.winCell = [];
      for (let i = 0; i < this.gameRow.length; i++) {
        if (this.drawResult[this.gameRow[i]] == "1") {
          this.winCell.push(this.gameRow[i]);
        }
      }
      return this.winCell;
    },
  },
  methods: {
    tabEnd() {
      this.$emit("on-tab-end");
    },
  },
};
</script>

<style lang="scss" scoped>
.fantan-mainbet {
  background-color: #000000;
  position: relative;
  width: 100%;
  padding: 0 0;
  height: 278px;
  // height: 200px;
  // @extend .game-section;
}

.divider {
  height: 30px;
  display: block;
  clear: both;
}

.square {
  width: 25%;
  float: left;
  background-color: #f3e8d4;
  position: relative;
  cursor: pointer; //1017 ADDED
}

.square1 {
  width: 75%;
  height: 73px;
  position: relative;
  cursor: pointer;
  border: 2px solid #111113;
  // border: 2px solid #464a4b;
  border-radius: 10px;
  padding: 8px 28px;
  text-align: left;
  background: transparent linear-gradient(180deg, #474b4c 0%, #111113 100%);

}

.square2 {
  width: 25%;
  height: 205px;
  position: absolute;
  cursor: pointer;
  cursor: pointer;
  border: 2px solid #111113;
  // border: 2px solid #464a4b;
  border-radius: 10px;
  top: 0px;
  right: 0;
  text-align: center;
  background: transparent linear-gradient(180deg, #474b4c 0%, #111113 100%);

}

.square3 {
  width: 25%;
  height: 205px;
  position: relative;
  cursor: pointer;
  border: 2px solid #111113;
  // border: 2px solid #464a4b;
  border-radius: 10px;
  text-align: center;
  background: transparent linear-gradient(180deg, #474b4c 0%, #111113 100%);

}

.square4 {
  width: 75%;
  height: 73px;
  position: absolute;
  cursor: pointer;
  border: 2px solid #111113;
  // border: 2px solid #464a4b;
  border-radius: 10px;
  bottom: 0px;
  right: 0;
  padding: 8px 28px;
  text-align: right;
  background: transparent linear-gradient(180deg, #474b4c 0%, #111113 100%);

}
.square-active {
  background: #6221f4;
  border: 2px solid #000000;
}
.square1.square-active {
  border-right: unset;
}
.square2.square-active {
  border-bottom: unset;
}
.square3.square-active {
  border-top: unset;
}
.square4.square-active {
  border-left: unset;
}

svg {
  height: 100%;
  width: 100%;
}

polygon {
  stroke-linejoin: round;
  stroke: black;
  stroke-width: 5px;
  stroke-linejoin: round;
}

.top {
  fill: yellow;
}

.left {
  fill: red;
}

.bottom {
  fill: white;
}

.right {
  fill: green;
}
</style>
